
/* 判断是否为微信或QQ环境 */
export function isWXOrQQ() {
    return isWX() || isQQ();
}

export function isWX() {
    var milieu = navigator.userAgent.toLowerCase();
    return milieu.indexOf('micromessenger') > -1;
}

export function isQQ() {
    var milieu = navigator.userAgent.toLowerCase();
    return milieu.indexOf("qqtheme") > -1;
}